export default __webpack_public_path__ + "static/media/T660_28A660A.78c85574.STEP";